import { SideBarContent, SidebarLayout } from "~/common/components";
import { hasGeneralAccess } from "~/common/utils/checkUserPermissions";
import { joinParams } from "~/common/utils/generateQueryString";
import { Item } from "~/common/utils/types/sideBarTypes";
import {
  useGetCurrentTeamMember,
  useGetHomeRoute,
  useSideBarItems,
} from "~/providers/hooks";
import { useUiStore } from "~/providers/stores/useUiStore";
import {
  defaultConsultationParams,
  defaultHomeParams,
  getFullName,
} from "~/providers/utils";

const TeamMemberSideBar = () => {
  const { homeRoute } = useGetHomeRoute();
  const { setSideBarOpen, sideBarOpen } = useUiStore();
  const { menuItems, middleMenuItems, bottomMenuItems } = useSideBarItems();

  const handleItemChange = (item: Item) => item.onClick();

  const { data: teamMember } = useGetCurrentTeamMember();

  const generalAccess = hasGeneralAccess(teamMember?.user_permissions);

  const params = generalAccess
    ? joinParams(defaultHomeParams)
    : joinParams(defaultConsultationParams);

  const handleOnClose = () => setSideBarOpen(false);

  return (
    <SidebarLayout isOpen={sideBarOpen} onClose={handleOnClose}>
      <SideBarContent
        menuItems={menuItems}
        middleMenuItems={middleMenuItems}
        bottomMenuItems={bottomMenuItems}
        handleItemChange={handleItemChange}
        onClose={handleOnClose}
        homePath={{
          pathname: homeRoute,
          search: params,
        }}
        user={{
          image: teamMember?.profile_picture_path,
          name: getFullName(teamMember?.name, teamMember?.last_name),
          organizationName:
            teamMember?.organization_team_members[0].organization.name,
        }}
      />
    </SidebarLayout>
  );
};

export default TeamMemberSideBar;
